import { IconButton } from "@mui/material";
import { colors } from "@mui/material";
import Icon from "./Icon";
import { Action, handleAction } from "./Action";

interface NavigationIconsProps {
  buttons: Action[];
}

const NavigationIcons = ({ buttons }: NavigationIconsProps) => {
  return (
    <div
      style={{
        display: "flex",
        textAlign: "center",
      }}
    >
      {buttons.map((action, index) => (
        <div
          key={index}
          style={{
            margin: "0 10px 0 10px",
            alignSelf: "flex-end",
          }}
        >
          <span style={{ display: 'inline-block' }}>
            <IconButton
              size="large"
              disabled={action.disabled}
              onClick={() => handleAction(action)}
              sx={{
                "&:hover, &.Mui-focusVisible": {
                  backgroundColor: "inherit",
                },
              }}
            >
              <Icon
                style={{
                  "&:hover": {
                    color: colors.indigo[700],
                  },
                }}
                fontIconClass={action.iconClass ?? ""}
                size="medium"
              />
            </IconButton>
          </span>
          <div
            style={{
              fontSize: "1rem",
              alignSelf: "flex-end",
            }}
          >
            {action.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NavigationIcons;
